import * as z from "zod";

export const zRequiredString = (message?: string, min = 1) =>
  z
    .string({
      required_error: message || "Requis",
    })
    .min(min, {
      message: message || "Requis",
    });
